import React, {Component} from 'react';


class Error extends Component {

    constructor(props) {
        super(props);
        this.state={}

    }



    render() {
        const { email, password, error } = this.state;
        const isInvalid = password === '' || email === '';
        return (
            <html lang="en">
            <head>
                <title>Login V3</title>
                <link rel="icon" type="image/png" href="images/icons/favicon.ico"/>
                <link rel="stylesheet" type="text/css" href="vendor/bootstrap/css/bootstrap.min.css"/>
                <link rel="stylesheet" type="text/css" href="fonts/font-awesome-4.7.0/css/font-awesome.min.css"/>
                <link rel="stylesheet" type="text/css" href="fonts/iconic/css/material-design-iconic-font.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/animate/animate.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/css-hamburgers/hamburgers.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/animsition/css/animsition.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/select2/select2.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/daterangepicker/daterangepicker.css"/>
                <link rel="stylesheet" type="text/css" href="css/util.css"/>
                <link rel="stylesheet" type="text/css" href="css/main.css"/>
            </head>
            <body>

            <div className="limiter">
                <div className="container-login100" style={{backgroundImage: "url('images/bgm.jpg')" }}>
                    {/*<div className={"container"}>*/}
                    <p>
                        <h1 style={{"color":"#fff"}}>
                            Something went Wrong...
                        </h1>
                    </p>

                    <br/>
                    <h2 className={"text-center"}>{this.props.error}</h2>


                </div>
                {/*<h3>We can't find the page you are looking For</h3>*/}

            </div>


            <div id="dropDownSelect1"></div>

            <script src="vendor/jquery/jquery-3.2.1.min.js"></script>
            <script src="vendor/animsition/js/animsition.min.js"></script>
            <script src="vendor/bootstrap/js/popper.js"></script>
            <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
            <script src="vendor/select2/select2.min.js"></script>
            <script src="vendor/daterangepicker/moment.min.js"></script>
            <script src="vendor/daterangepicker/daterangepicker.js"></script>
            <script src="vendor/countdowntime/countdowntime.js"></script>
            <script src="js/main.js"></script>

            </body>
            </html>


        );
    }
}

export default Error;